import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { lowerCase } from "lodash";
import { AdminService } from "../admin.service";
import { OtpVerifyComponent } from "src/app/shared-modules/otp-verify/otp-verify.component";

@Component({
  selector: "app-admin-users-truckowner-view",
  templateUrl: "./admin-users-truckowner-view.component.html",
  styleUrls: ["./admin-users-truckowner-view.component.css"],
})
export class AdminUsersTruckownerViewComponent implements OnInit {
  truckOwner: any;
  truckProfile: boolean = true;
  editTruckProfile: boolean = false;
  editTrucksFrom: FormGroup;
  send_otp: boolean = true;
  otp_verify: boolean = false;
  otp_ver: boolean = false;
  otpVerify: boolean = false;
  ismobileVerified: boolean = false;
  truckowner_verify_otp: boolean = false;
  truckImage: any;
  ref_id: any;
  loading: boolean = false;
  ngOtpInputRef: any;
  file: any = "";
  token: any;
  minDob = new Date();
  perPage: any = 10;
  truckStartPage: any = 1;
  otpCode: any;
  mobileOtp: any;
  emailregex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/;
  loginResponse: any;
  public mobileVerified = 0;
  submitted = false;
  truckownerMobile = -1;
  editing: boolean = false;

  constructor(
    private matdialogref: MatDialogRef<AdminUsersTruckownerViewComponent>,
    private matDialog: MatDialog,
    private formBuilder: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private services: AdminService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.truckOwner = this.data;
    this.token = localStorage.getItem("adminToken");
    this.editTrucksFrom = this.formBuilder.group({
      username: ["", Validators.required],
      mobile: [
        "",
        Validators.compose([
          Validators.required,
          Validators.pattern("^[0-9]{4,10}$"),
        ]),
      ],
      email: [
        "",
        [
          Validators.email,
          Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,4}$"),
        ],
      ],
      dob: ["", [Validators.required]],
      gender: [""],
      account_name: [""],
      accountr_number: [""],
      bank_name: [""],
      branch_name: [""],
      ifsc_code: [""],
      sms_alert: [false],
    });
    this.fetchInitialData();
  }
  fetchInitialData(): void {
    const response = { mobile_verified: 1 };
    this.mobileVerified = response.mobile_verified;
    this.ismobileVerified = this.mobileVerified === 1;
  }

  close() {
    this.matdialogref.close();
  }
  truckOwnerGet() {
    this.services
      .getUsersTruckOwner(
        this.token,
        this.perPage,
        this.truckStartPage,
        this.truckownerMobile
      )
      .subscribe(
        (response: any) => {},
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }

  public get editFormControl() {
    return this.editTrucksFrom.controls;
  }

  editUserTruck() {
    this.editing = true;
    this.ismobileVerified = false;
    this.editTruckProfile = true;
    this.truckProfile = false;
    this.truckImage = this.truckOwner.registerInfo[0]?.profile_pic;
    this.editTrucksFrom.patchValue({
      username: this.truckOwner.username,
      mobile: this.truckOwner.mobile,
      email: this.truckOwner.registerInfo[0]?.email,
      gender: this.truckOwner.registerInfo[0]?.gender,
      account_name:
        this.truckOwner.registerInfo[0]?.account_details?.account_name,
      accountr_number:
        this.truckOwner.registerInfo[0]?.account_details?.accountr_number,
      bank_name: this.truckOwner.registerInfo[0]?.account_details?.bank_name,
      branch_name:
        this.truckOwner.registerInfo[0]?.account_details?.branch_name,
      ifsc_code: this.truckOwner.registerInfo[0]?.account_details?.ifsc_code,
      sms_alert: this.truckOwner.registerInfo[0]?.sms_alert,
    });
  }
  public Otpsend(): void {
    if (!this.editTrucksFrom.controls["mobile"].valid) {
      this.editTrucksFrom.controls["mobile"].markAsTouched();
      return;
    }
    const dataValue = {
      mobile: this.editTrucksFrom.value.mobile,
      displayText: "Mobile Number",
      from: "userCustomer",
      user_type: this.data.user_type || "",
      ref_id: this.data.ref_id,
    };
    let matDialogref = this.matDialog.open(OtpVerifyComponent, {
      width: "500px",
      data: {
        dataKey: dataValue,
      },
    });
    matDialogref.afterClosed().subscribe((res: any) => {
      if (res.event === "Success") {
        this.mobileVerified = 1;
        this.ismobileVerified = true;
      }
    });
  }

  onOtpChange(code: string): void {
    this.otpCode = code;
    if (code.length == 4) {
    }
  }

  public onChange(event: any): void {
    this.file = event.target.files[0];
    this.services.uploadImage(this.file).subscribe(
      (response: any) => {
        if (response.status == 201) {
          this.truckImage = response.body.image_link;
        }
      },
      (error) => {
        if (error.error.message === "jwt malformed") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "jwt expired") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        if (error.error.message === "invalid signature") {
          this.router.navigateByUrl("admin/login");
          window.localStorage.clear();
        }
        this.snackBar.open(error.error.message, "Fail", {
          duration: 5000,
        });
      }
    );
  }

  get f() {
    return this.editTrucksFrom.controls;
  }

  updateTruckowner() {
    let name = this.editTrucksFrom.value.username;
    if (!name) {
      this.snackBar.open("Please enter username", "Fail", {
        duration: 5000,
      });
      return;
    }
    if (this.mobileVerified !== 1) {
      this.snackBar.open("Please Verify mobile number", "Fail", {
        duration: 5000,
      });
      return;
    }
    let email = this.editTrucksFrom.value.email;
    if (!email) {
      this.snackBar.open("Please enter email", "Fail", {
        duration: 5000,
      });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      this.snackBar.open("Please enter a valid email", "Fail", {
        duration: 5000,
      });
      return;
    }

    const billingObj = {
      address_line:
        this.truckOwner.registerInfo[0]?.billing_address?.address_line,
      area_name: this.truckOwner.registerInfo[0]?.billing_address?.area_name,
      city: this.truckOwner.registerInfo[0]?.billing_address?.city,
      state: this.truckOwner.registerInfo[0]?.billing_address?.state,
      pincode: this.truckOwner.registerInfo[0]?.billing_address?.pincode,
      landmark: this.truckOwner.registerInfo[0]?.billing_address?.area_name,
    };
    const account_details = {
      account_name: this.editTrucksFrom.value.account_name,
      accountr_number: Number(this.editTrucksFrom.value.accountr_number),
      bank_name: this.editTrucksFrom.value.bank_name,
      branch_name: this.editTrucksFrom.value.branch_name,
      ifsc_code: this.editTrucksFrom.value.ifsc_code,
    };
    const truckObj = {
      username: this.editTrucksFrom.value.username,
      mobile: this.editTrucksFrom.value.mobile,
      email: this.editTrucksFrom.value.email,
      dob: this.truckOwner.registerInfo[0]?.dob,
      gender: this.editTrucksFrom.value.gender,
      company_name: this.truckOwner.registerInfo[0]?.company_name,
      gst: this.truckOwner.registerInfo[0]?.gst,
      gst_verified:
        this.truckOwner.registerInfo[0]?.gst_verified === true ||
        this.truckOwner.registerInfo[0]?.gst_verified === 1,
      pan: this.truckOwner.registerInfo[0]?.pan,
      pan_verified:
        this.truckOwner.registerInfo[0]?.pan_verified === true ||
        this.truckOwner.registerInfo[0]?.pan_verified === 1,
      profile_pic: this.truckImage,
      billing_address: billingObj,
      account_details: account_details,
      sms_alert: this.editTrucksFrom.value.sms_alert,
    };
    this.services
      .truckOwnerUpdate(truckObj, this.token, this.truckOwner._id)
      .subscribe(
        (response: any) => {
          if (response.status == 200) {
            this.matdialogref.close();
            this.snackBar.open(
              "Truckowner details updated successfully",
              "Success",
              {
                duration: 5000,
              }
            );
          }
        },
        (error) => {
          if (error.error.message === "jwt malformed") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "jwt expired") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          if (error.error.message === "invalid signature") {
            this.router.navigateByUrl("admin/login");
            window.localStorage.clear();
          }
          this.snackBar.open(error.error.message, "Fail", {
            duration: 5000,
          });
        }
      );
  }
  onMobileInputChange(): void {
    if (this.editing) {
      this.mobileVerified = 0;
    }
  }
  onEditClick() {}
  public onDateChnage(num: number) {}
}
